export default class SessionStorage {
    static getItem(key) {
        try {
            const str = sessionStorage.getItem(key);
            if (!str)
                return undefined;
            return JSON.parse(str);
        }
        catch (error) { // ignore error
            return undefined;
        }
    }
    static setItem(key, data) {
        if (data === undefined) {
            sessionStorage.removeItem(key);
        }
        else {
            sessionStorage.setItem(key, JSON.stringify(data));
        }
    }
}
//# sourceMappingURL=SessionStorage.js.map